export function removeTypename(obj) {
  delete obj.__typename;
  return obj;
}

export function removeId(obj) {
  delete obj.id;
  return obj;
}
